// units/state.js

export const unitsInitialState = {
  list: [],
  loading: false,
  error: null,
};
